export interface IAnalyticsHandler {
  log(logEvent: string, options: any): void;
}

export abstract class AnalyticsHandler implements IAnalyticsHandler {
  public abstract log(logEvent: string, options: any): void;
  protected abstract initialize(): void; //eslint-disable-line
}
